const GFFeeCover = () => {
    (function () {
        var donationFormIds = [4, 32, 38, 94];

        /**
         * Check whether the form should use the fee cover total.
         *
         * @param {number|string} formId The Gravity Forms form ID.
         * @returns {boolean}
         */
        function isDonationForm(formId) {
            return donationFormIds.indexOf(parseInt(formId, 10)) !== -1;
        }

        /**
         * Update all fee cover amount text instances for a Gravity Form.
         *
         * @param {number|string} formId The Gravity Forms form ID.
         */
        function updateFeeCoverAmount(formId) {
            if (!isDonationForm(formId)) {
                return;
            }

            formId = parseInt(formId, 10);

            var formWrapper = document.getElementById('gform_wrapper_' + formId);

            if (!formWrapper) {
                return;
            }

            var outputs = formWrapper.querySelectorAll('.gform__fee-cover-total');

            if (!outputs.length) {
                return;
            }

            var feeValue = '';
            var feeInput = formWrapper.querySelector('#input_' + formId + '_35_2');
            var feeText = formWrapper.querySelector(
                '#field_' + formId + '_35 .ginput_product_price'
            );
            var feeTotal = formWrapper.querySelector('#field_' + formId + '_35 .ginput_total');

            if (feeInput && feeInput.value) {
                feeValue = feeInput.value;
            } else if (feeText && feeText.textContent) {
                feeValue = feeText.textContent.trim();
            } else if (feeTotal && feeTotal.textContent) {
                feeValue = feeTotal.textContent.trim();
            }

            if (!feeValue) {
                return;
            }

            for (var i = 0; i < outputs.length; i++) {
                outputs[i].textContent = feeValue;
            }
        }

        document.addEventListener('gform/post_init', function (event) {
            updateFeeCoverAmount(event.detail.formId);
        });

        document.addEventListener('gform/theme/scripts_loaded', function () {
            if (typeof gform === 'undefined') {
                return;
            }

            if (typeof gform.addFilter === 'function') {
                gform.addFilter('gform_product_total', function (total, formId) {
                    window.setTimeout(function () {
                        updateFeeCoverAmount(formId);
                    }, 0);

                    return total;
                });
            }

            if (typeof gform.addAction === 'function') {
                gform.addAction('gform_post_conditional_logic_field_action', function (formId) {
                    window.setTimeout(function () {
                        updateFeeCoverAmount(formId);
                    }, 0);
                });
            }
        });

        document.addEventListener('gform/products/product_field_changed', function (event) {
            if (!event.detail || !event.detail.formId) {
                return;
            }

            window.setTimeout(function () {
                updateFeeCoverAmount(event.detail.formId);
            }, 0);
        });

        document.addEventListener('change', function (event) {
            var field = event.target.closest(
                '#gform_wrapper_4 input, #gform_wrapper_4 select, #gform_wrapper_4 textarea, #gform_wrapper_32 input, #gform_wrapper_32 select, #gform_wrapper_32 textarea'
            );

            if (!field) {
                return;
            }

            var formWrapper = field.closest('[id^="gform_wrapper_"]');

            if (!formWrapper) {
                return;
            }

            var formId = formWrapper.id.replace('gform_wrapper_', '');

            window.setTimeout(function () {
                updateFeeCoverAmount(formId);
            }, 0);
        });
    })();
};

export default GFFeeCover;
